// extracted by mini-css-extract-plugin
module.exports = {"container":"Imagem_container__3COwV","imagem":"Imagem_imagem__3ubpT","info":"Imagem_info__1jVXq","descricao":"Imagem_descricao__lBsMe","opcoes":"Imagem_opcoes__2PKd2"};